import { render, staticRenderFns } from "./PartnersKeysEdit.vue?vue&type=template&id=8cccd104&"
import script from "./PartnersKeysEdit.vue?vue&type=script&lang=js&"
export * from "./PartnersKeysEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports